<div id="MeasureComponent" class="card esri-widget animation-on-tool-open" gisDraggableWidget [dragHandle]="dragHandle"
     #measureComponentRef>
  <!--- the card header -->
  <div class="card-header" #dragHandle>
    <div class="row">
      <div class="col-md-9" translate>
        WIDGET.MEASURE.PANEL_HEADING
      </div>
      <div class="col-md-3">
        <i class="material-icons md-18 float-right" (click)="destroySelf()">close</i>
        <i class="material-icons md-18 float-right pr-1" (click)="collapseWidget()">exit_to_app</i>
      </div>
    </div>
  </div>
  <!-- the card body -->
  <div class="card-body">
    <div class="row">
      <div class="col text-center">
        <button id="distance-button" class="btn btn-sm btn-light btn-block"
                (click)="createDistanceMeasure()" translate>WIDGET.MEASURE.MEASURE_NEW_LINE
        </button>
      </div>
      <div class="col text-center">
        <button id="area-button" class="btn btn-sm btn-light btn-block"
                (click)="createAreaMeasure()" translate>WIDGET.MEASURE.MEASURE_NEW_AREA
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div id="measure-toolbox-div-{{i}}" *ngFor="let m of measurements; let i = index">
          <measure-toolbox [activeWidget]="m" [measureNumber]="i+1"></measure-toolbox>
        </div>
      </div>
    </div>

  </div>
</div>
